import { render } from "./PeerToPeerAssessment.vue?vue&type=template&id=5f905949"
import script from "./PeerToPeerAssessment.vue?vue&type=script&lang=js"
export * from "./PeerToPeerAssessment.vue?vue&type=script&lang=js"

import "./PeerToPeerAssessment.vue?vue&type=style&index=0&id=5f905949&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__